import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<
  { showArrows: boolean },
  "arrowIconButton"
>()((theme, { showArrows }, classes) => ({
  mainContent: {
    width: "100%",
    display: "flex",
    gap: theme.spacing(2),
  },
  wrapper: {
    flex: 1,
    padding: theme.spacing(0, 2),
  },
  contentInner: {
    display: "flex",
    gap: theme.spacing(6),
    justifyContent: "center",
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  imageViewer: {
    maxWidth: "30vw",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  genDetails: {
    width: 320,
    maxHeight: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  prompt: {
    fontSize: "2rem",
    fontWeight: 700,
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.5rem",
    },
  },
  genDetailsMain: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "space-between",
  },
  createdAt: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    margin: theme.spacing(2, 0),
  },
  genControls: {
    display: "flex",
  },
  description: {
    fontSize: "1.25rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
  genNavControls: {
    width: "100%",
    display: showArrows ? "flex" : "none",
    justifyContent: "space-between",
    alignItems: "center",
  },
  arrowGroup: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.secondary.main,
      [`& .${classes.arrowIconButton}`]: {
        color: theme.palette.secondary.main,
      },
    },
  },
  arrowText: {
    fontWeight: 500,
  },
  arrowIconButton: {
    fontSize: "3rem",
    cursor: "pointer",
    color: theme.palette.text.secondary,
  },
  commentsContainer: {
    paddingTop: theme.spacing(4),
  },
}));
